module.exports = __webpack_public_path__ + "static/media/nader.2c59c68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/nader.png
// module id = 298
// module chunks = 0